import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "compliance-tr"
  }, [_c('div', {
    staticClass: "compliance-td checkbox"
  }, [_c('a-checkbox', {
    attrs: {
      "value": _vm.data.product_sku
    }
  })], 1), _c('div', {
    staticClass: "compliance-td item1",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.product_sku) + " ")]), _c('div', {
    staticClass: "compliance-td item2"
  }, [_vm._v(" " + _vm._s(_vm.data.import_country) + "[" + _vm._s(_vm.data.import_country_name) + "] ")]), _c('div', {
    staticClass: "compliance-td item3"
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "data." + _vm.index + ".compliance_officer_id_list",
      "rules": _vm.formDataRule['data.*.compliance_officer_id_list']
    }
  }, [_c('my-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "option-filter-prop": "children",
      "placeholder": _vm.t('请选择合规负责人')
    },
    model: {
      value: _vm.data._compliance_officer_id,
      callback: function ($$v) {
        _vm.$set(_vm.data, "_compliance_officer_id", $$v);
      },
      expression: "data._compliance_officer_id"
    }
  }, _vm._l(_vm.filterComplianceOfficerList, function (item) {
    return _c('a-select-option', {
      key: item.id,
      attrs: {
        "title": item.country_code + item.country_name + item.company
      }
    }, [_vm._v(" " + _vm._s(item.country_code) + "[" + _vm._s(item.country_name) + "] " + _vm._s(item.company) + " ")]);
  }), 1)], 1)], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };